var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "currentColor",
    viewBox: "0 0 13 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.515 11.69h.934l5.75-5.75-.934-.934-5.75 5.75v.934Zm9.534-6.717-2.834-2.8.934-.933a1.28 1.28 0 0 1 .942-.384c.372 0 .686.128.941.384l.934.933c.255.256.388.564.4.925.01.361-.112.67-.367.925l-.95.95Zm-10.2 8.05a.643.643 0 0 1-.475-.192.643.643 0 0 1-.192-.475v-1.883a.687.687 0 0 1 .2-.483L7.25 3.123l2.833 2.833-6.867 6.867a.666.666 0 0 1-.483.2H.85Zm6.883-7.55-.467-.467.934.934-.467-.467Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.d6ab61a1ad311ebbe2703aba135c2a66.svg";
export { ForwardRef as ReactComponent };